export default async function handleFormSubmission(event) {
    event.preventDefault();

    let isSubmitting = false; // Initialize the flag

    // Prevent form submission if already submitting
    if (isSubmitting) {
        return;
    }

    // Set the isSubmitting flag to true during form submission
    isSubmitting = true;

    const formMessage = document.getElementById('formMessage'); // Get form message container

    try {
        // Validate the form before submitting
        if (validateForm()) {
            const formData = new FormData(event.target);
            const data = {};

            formData.forEach((value, key) => {
                data[key] = value;
            });

            const response = await fetch('https://static-send.inoryum.com/email-send', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data),
            });

            if (response.ok) {
                showFormMessage('Email sent successfully!', 'success');
                event.target.reset();
            } else {
                const errorMessage = await response.text();
                showFormMessage(`Failed to send email: ${errorMessage}`, 'error');
            }
        } else {
            // Reset the isSubmitting flag to false if the form validation failed
            isSubmitting = false;
        }
    } catch (error) {
        showFormMessage('An error occurred while sending the email.', 'error');
        console.error('Error:', error);
    } finally {
        // Reset the isSubmitting flag to false after form submission
        isSubmitting = false;
    }
}

function validateForm() {
    const requiredFields = document.querySelectorAll('[data-required]');
    let isValid = true;

    // Reset previous error messages
    formMessage.innerHTML = '';

    requiredFields.forEach((field) => {
        if (field.value.trim() === '') {
            showFormMessage(`Please fill in the "${field.dataset.label}" field.`, 'error');
            field.focus();
            isValid = false;
        }
    });

    return isValid;
}

function showFormMessage(message, messageType) {
    const form = document.querySelector('[data-send]'); // Get the form
    form.classList.remove('sending', 'success', 'error'); // Remove previous state classes
    form.classList.add(messageType); // Add the new state class

    const messageElement = document.createElement('div');
    messageElement.classList.add('message');
    messageElement.textContent = message;
    form.appendChild(messageElement); 

    setTimeout(() => {
        form.removeChild(messageElement);
    }, 15000); 
}